export const waspContactInfo = {
  email: 'wasp.uhasselt@gmail.com',
  tel: '+32 (0)11 268 111',
  fax: '+32 (0)11 268 199',
  address: {
    oneLine: 'Agoralaan – Building D, 3590 Diepenbeek - Belgium',
    multiLine: [
      'Agoralaan - Building D',
      '3590 Diepenbeek - Belgium'
    ]
  }
}
